export const createMonotoneCubic = (xs: number[], ys: number[]): ((x: number) => number) => {
    const count = xs.length;

    if (count < 2) {
        return () => ys[0];
    }

    const deltas = xs.slice(0, -1).map((x, index) => (ys[index + 1] - ys[index]) / (xs[index + 1] - x));
    const slopes = xs.map((_, index) => {
        if (index === 0) {
            return deltas[0];
        }

        if (index === count - 1) {
            return deltas[count - 2];
        }

        return deltas[index - 1] * deltas[index] <= 0 ? 0 : (deltas[index - 1] + deltas[index]) / 2;
    });

    deltas.forEach((delta, index) => {
        if (delta === 0) {
            slopes[index] = 0;
            slopes[index + 1] = 0;
            return;
        }

        const alpha = slopes[index] / delta;
        const beta = slopes[index + 1] / delta;
        const magnitude = alpha * alpha + beta * beta;

        if (magnitude > 9) {
            const tau = 3 / Math.sqrt(magnitude);

            slopes[index] = tau * alpha * delta;
            slopes[index + 1] = tau * beta * delta;
        }
    });

    return (x) => {
        if (x <= xs[0]) {
            return ys[0];
        }

        if (x >= xs[count - 1]) {
            return ys[count - 1];
        }

        let index = 0;

        while (x > xs[index + 1]) {
            index++;
        }

        const width = xs[index + 1] - xs[index];
        const t = (x - xs[index]) / width;
        const t2 = t * t;
        const t3 = t2 * t;

        return (
            (2 * t3 - 3 * t2 + 1) * ys[index] +
            (t3 - 2 * t2 + t) * width * slopes[index] +
            (-2 * t3 + 3 * t2) * ys[index + 1] +
            (t3 - t2) * width * slopes[index + 1]
        );
    };
};
export const createMonotoneCubic = (xs: number[], ys: number[]): ((x: number) => number) => {
    const count = xs.length;

    if (count < 2) {
        return () => ys[0];
    }

    const deltas = xs.slice(0, -1).map((x, index) => (ys[index + 1] - ys[index]) / (xs[index + 1] - x));
    const slopes = xs.map((_, index) => {
        if (index === 0) {
            return deltas[0];
        }

        if (index === count - 1) {
            return deltas[count - 2];
        }

        return deltas[index - 1] * deltas[index] <= 0 ? 0 : (deltas[index - 1] + deltas[index]) / 2;
    });

    deltas.forEach((delta, index) => {
        if (delta === 0) {
            slopes[index] = 0;
            slopes[index + 1] = 0;
            return;
        }

        const alpha = slopes[index] / delta;
        const beta = slopes[index + 1] / delta;
        const magnitude = alpha * alpha + beta * beta;

        if (magnitude > 9) {
            const tau = 3 / Math.sqrt(magnitude);

            slopes[index] = tau * alpha * delta;
            slopes[index + 1] = tau * beta * delta;
        }
    });

    return (x) => {
        if (x <= xs[0]) {
            return ys[0];
        }

        if (x >= xs[count - 1]) {
            return ys[count - 1];
        }

        let index = 0;

        while (x > xs[index + 1]) {
            index++;
        }

        const width = xs[index + 1] - xs[index];
        const t = (x - xs[index]) / width;
        const t2 = t * t;
        const t3 = t2 * t;

        return (
            (2 * t3 - 3 * t2 + 1) * ys[index] +
            (t3 - 2 * t2 + t) * width * slopes[index] +
            (-2 * t3 + 3 * t2) * ys[index + 1] +
            (t3 - t2) * width * slopes[index + 1]
        );
    };
};
